import { useCallback } from 'react';
import { from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { GET_AVAILABILITY_STORES_ENDPOINT } from '@redux/epic/bopis/getAvailabilityStores/configs';
import { postAsObservable } from '@services/genericService';

const useFetchAvailabilityStores = () => {
  return useCallback(
    /** @param {Object} payload
     * @param {Array} payload.ListProducts
     * @param {Number} payload.Type*/
    async (payload) => {
      return await new Promise((resolve, reject) => {
        return from(postAsObservable(GET_AVAILABILITY_STORES_ENDPOINT, payload))
          .pipe(
            map((res) => {
              if (res.status === 200) {
                return resolve(res.data);
              }

              return resolve([]);
            }),
            catchError((error) => reject(error.message || 'Failed'))
          ).subscribe((data) => resolve(data), (error) => reject(error.message || 'Failed'));
      });
    }, []);
};

export default useFetchAvailabilityStores;